import React, {useContext} from 'react';
import GettingStartedContext from "../utils/GettingStartedContext";

const Logo = ({url}) => {

  const {
    isFr
  } = useContext(GettingStartedContext)

  return <a href={url} className="gsa__header-logo">
    {isFr() ?
      <img src="/_resources/themes/airsprint/images/logo-white-fr.svg" /> :
      <img src="/_resources/themes/airsprint/images/logo-white.svg" />
    }
  </a>
}

export default Logo;
